<template>
  <main class="login-panel">
    <form @submit.prevent="submit">
      <h2>登录 STN 工作台</h2>
      <p>使用现有 ai-token 账号，进入你的个人工作区。</p>
      <label for="stn-username">用户名</label><input id="stn-username" v-model="username" autocomplete="username" required :disabled="busy" />
      <label for="stn-password">密码</label><input id="stn-password" v-model="password" type="password" autocomplete="current-password" required :disabled="busy" />
      <p v-if="error || auth.error" class="error" role="alert">{{ error || auth.error }}</p>
      <button type="submit" :disabled="busy">{{ busy ? '登录中…' : '登录' }}</button>
      <button v-if="auth.error" type="button" :disabled="busy" class="secondary" @click="retry">重试已有登录</button>
      <a href="/ai-token/" target="_blank" rel="noopener">注册 / 找回密码 / 账号中心</a>
    </form>
  </main>
</template>
<script>
import { auth, login, restoreSession } from '../api/auth'
export default {
  name: 'LoginPanel',
  data: () => ({ auth, username: '', password: '', error: '', busy: false }),
  methods: {
    async submit() {
      this.busy = true; this.error = ''
      try { await login(this.username.trim(), this.password) }
      catch (error) { this.error = error.message }
      finally { this.password = ''; this.busy = false }
    },
    async retry() { this.busy = true; try { await restoreSession() } finally { this.busy = false } }
  }
}
</script>
<style scoped>
.login-panel { flex: 1; display: grid; place-items: center; padding: 24px; }
.login-panel form { width: min(400px, 100%); padding: 32px; border-radius: 14px; background: white; box-shadow: 0 12px 40px #0f172a12; }
.login-panel h2 { margin: 0 0 12px; }
.login-panel p { color: #64748b; line-height: 1.6; }
.login-panel label { display: block; margin: 18px 0 8px; }
.login-panel input { box-sizing: border-box; width: 100%; padding: 12px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 15px; }
.login-panel button { width: 100%; margin-top: 22px; padding: 12px; background: #096dd9; border: 0; border-radius: 6px; color: white; cursor: pointer; }
.login-panel button:disabled { opacity: .5; }
.login-panel .secondary { background: #e6f4ff; color: #096dd9; margin-top: 10px; }
.login-panel a { display: block; text-align: center; margin-top: 20px; color: #096dd9; font-size: 13px; }
.login-panel .error { color: #b91c1c; }
</style>
